module.exports = __webpack_public_path__ + "media/Slide11.3a57d8c2.mp3";